<template>
	<div class="links" :class="theme">
		<a @click.prevent="terms" href="">{{ t('terms') }}</a>
		<span></span>
		<a @click.prevent="privacy" href="">{{ t('privacy') }}</a>
		<span></span>
		<a @click.prevent="$emit('restore')" href="">{{ t('restore') }}</a>
	</div>
</template>

<script setup>
import useApi from '@/composition/api'
import { useI18n } from 'vue-i18n'

const api = useApi()
const { t } = useI18n()
const { terms, privacy } = api

// eslint-disable-next-line no-undef
defineEmits(['restore'])
// eslint-disable-next-line no-undef
defineProps({
	theme: {
		type: String,
		default: 'default'
	}
})
</script>

<style scoped lang="scss">
.links {
	&.default {
		--links-text-color: #3b3c57;
	}
	&.light {
		--links-text-color: #979aaa;
	}

	&.dark {
		--links-text-color: #737587;
	}

	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1.4rem;
	flex-wrap: wrap;

	span {
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: #3b3c57;
		margin: 2px 12px;
		opacity: 0.5;
	}

	a {
		text-decoration: none;
		color: var(--links-text-color);
		font-size: 0.9rem;
		display: block;
		margin: 2px 0;
	}
}

[lang='fr'],
[lang='de'] {
	.links a {
		font-size: 0.8rem;
	}
}
</style>
